import { useEffect, useState } from "react";
import MainCard from "components/MainCard";
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { getRequest } from "utils/apiRequest";
import { Notice } from "components/Notice";
import { getUrlForPath } from "utils/functions";
import Image from "components/Image";

const headCells = [
  {
      id: 'image',
      align: 'left',
      disablePadding: false,
      label: ''
  },
  {
      id: 'productName',
      align: 'left',
      disablePadding: true,
      label: 'Product'
  },
  {
      id: 'zipCodeTo',
      align: 'left',
      disablePadding: true,
      label: 'Zip Code To'
  },
  {
      id: 'warehouse',
      align: 'left',
      disablePadding: true,
      label: 'Warehouse'
  },
  {
      id: 'viewedOn',
      align: 'left',
      disablePadding: true,
      label: 'Viewed On'
  },
  {
      id: 'estDeliveryDate',
      align: 'center',
      disablePadding: false,
      label: 'Estimated Delivery Date'
  },
  {
      id: 'days',
      align: 'center',
      disablePadding: false,
      label: 'Days'
  },
];
function createData(image, productName, zipCodeTo, warehouse, viewedOn, estDeliveryDate, days) {
    return { image, productName, zipCodeTo, warehouse, viewedOn, estDeliveryDate, days };
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function RecentlyViewedEstimatesTableHead({ order, orderBy }) {
  return (
      <TableHead>
          <TableRow>
              {headCells.map((headCell) => (
                  <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      padding={headCell.disablePadding ? 'none' : 'normal'}
                      sortDirection={orderBy === headCell.id ? order : false}
                  >
                      {headCell.label}
                  </TableCell>
              ))}
          </TableRow>
      </TableHead>
  );
}

export function RecentlyViewedProductEstimatedDates() {
  const [isLoading, setIsLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [order] = useState('desc');
  const [orderBy] = useState('viewedOn');
  const [selected] = useState([]);

    useEffect(()=>{
      setIsLoading(true);
        getRequest('/logs/estimates').then((data) => {
          const rows = [];
          if(data && data.data){
              data.data.forEach((d) => {
                const create_date = new Date(d.created_at);
                const est_date = new Date(d.estimated_date);
                if(d.product){
                  rows.push(createData(
                    d.product.image_url, 
                    d.product.name, 
                    d.zip_to, 
                    d.warehouse.name, 
                    new Intl.DateTimeFormat('en-US').format(create_date), 
                    new Intl.DateTimeFormat('en-US').format(est_date), 
                    Math.ceil(d.transit_time_hours / 24)
                  ));
                }
              })
              setLogs(rows);
              // setPagination({
              //     current: data.current_page,
              //     total: data.last_page,
              // })
          }
      }).finally(() => {
        setIsLoading(false);
      })
    }, []);


  return (<MainCard title={"Recently Viewed Estimates Delivery Dates"}>
    {isLoading || logs.length > 0 ? (
  <Box>
      <TableContainer
          sx={{
              width: '100%',
              overflowX: 'auto',
              position: 'relative',
              display: 'block',
              maxWidth: '100%',
              '& td, & th': { whiteSpace: 'nowrap' }
          }}
      >
          <Table
              aria-labelledby="tableTitle"
              sx={{
                  '& .MuiTableCell-root:first-of-type': {
                      pl: 2
                  },
                  '& .MuiTableCell-root:last-child': {
                      pr: 3
                  }
              }}
          >
              <RecentlyViewedEstimatesTableHead order={order} orderBy={orderBy} />
              <TableBody>
                  {isLoading ? ([...Array(10)].map((k, i) => {
                  return (<TableRow key={i}>
                      <TableCell align="left"><Skeleton variant="text" width="70%" /></TableCell>
                      <TableCell align="left"><Skeleton variant="text" width="70%" /></TableCell>
                      <TableCell align="left"><Skeleton variant="text" width="70%" /></TableCell>
                      <TableCell align="left"><Skeleton variant="text" width="70%" /></TableCell>
                      <TableCell align="left"><Skeleton variant="text" width="70%" /></TableCell>
                      <TableCell align="center"><Skeleton variant="text" width="70%" /></TableCell>
                      <TableCell align="center"><Skeleton variant="text" width="70%" /></TableCell>
                  </TableRow>)
                  })
                  ) : (<>
                  {stableSort(logs, getComparator(order, orderBy)).map((row, index) => {

                      return (
                          <TableRow
                              hover
                              role="checkbox"
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                              tabIndex={-1}
                              key={index}
                          >
                              <TableCell align="left">
                                  <Link color="secondary" component={RouterLink} to="">
                                      <Image src={row.image} width={32} height={32} />
                                  </Link>
                              </TableCell>
                              <TableCell align="left">
                                  {row.productName}
                              </TableCell>
                              <TableCell align="left">
                                  <Link color="secondary" href={getUrlForPath("maps/recent/" + row.zipCodeTo)}>
                                      {row.zipCodeTo}
                                  </Link>
                              </TableCell>
                              <TableCell align="left">{row.warehouse}</TableCell>
                              <TableCell align="left">{row.viewedOn}</TableCell>
                              <TableCell align="center">{row.estDeliveryDate}</TableCell>
                              <TableCell align="center">{row.days}</TableCell>
                          </TableRow>
                      );
                  }
                  )}</>)}
              </TableBody>
          </Table>
      </TableContainer>
  </Box>) : (
    <Notice>No data. Data will populate as users view or interact with the Estimated Delivery Date componenent on your website. If you have not integrated with your website, view our <a href={process.env.REACT_APP_DOCS_URL} target="_blank">documentation</a> to get started.</Notice>
  )}
  </MainCard>
  );
}
